// extracted by mini-css-extract-plugin
module.exports = {"errorNoAcess":"styles_errorNoAcess__2HYen","plug":"styles_plug__1J7_l"};